import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-contentReview",
  "use": "icon-contentReview-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-contentReview\"><path d=\"M57.12908 396.191661l2.10483-310.206494c0-59.276576 22.754923-84.534541 83.226133-85.330963 250.361046-0.85331 500.722091-0.85331 751.253798 0 52.905197 0 80.666204 26.054387 81.462626 83.738118 0.455098 36.237216 0.568873 140.682314 0.22755 313.335297a56.887309 56.887309 0 0 1-56.887309 56.716646L113.959501 453.477181a56.887309 56.887309 0 0 1-56.830421-57.28552z m-0.170662 455.382906l0.910197-281.478403a56.887309 56.887309 0 0 1 56.659759-56.659759l340.072332-1.194634a56.887309 56.887309 0 0 1 57.114857 56.887309v283.469459a56.887309 56.887309 0 0 1-57.05797 56.887309l-341.039416-0.85331a56.830421 56.830421 0 0 1-56.659759-57.057971z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/contentReview.svg
// module id = CwCY
// module chunks = 78